import PageData from './src/page-data';
import store from './src/store';
export default PageData;
export {
    store as pageDataStore,
};
